import React from 'react';
import PropTypes from 'prop-types';
import { VALID_DIRECTIONS } from './constants';

const INFINITE_SPACE = {
    left: Infinity,
    right: Infinity,
    top: Infinity,
    bottom: Infinity,
};

const defaultArrowLocationPredicate = (availableSpace) => {
    const MIN_SPACE = 250;

    return (
        VALID_DIRECTIONS.find(
            (direction) => availableSpace[direction] > MIN_SPACE,
        ) || VALID_DIRECTIONS[0]
    );
};

const withTooltipArrowLocationCalculator = (WithTooltipWrapper) =>
    class TooltipArrowLocationCalculator extends React.PureComponent {
        static propTypes = {
            /**
             * Function that takes this.state.availableSpace and returns a valid arrowLocation
             * to pass to the wrapped tooltip
             **/
            arrowLocationPredicate: PropTypes.func,
        };

        static defaultProps = {
            arrowLocationPredicate: defaultArrowLocationPredicate,
        };

        state = {
            availableSpace: INFINITE_SPACE,
        };

        _handleUpdateDistances = () => {
            const nodeRects =
                this._rootNode.getClientRects()[0] || INFINITE_SPACE;

            const { left, right, top, bottom } = nodeRects;

            const { innerHeight, innerWidth } = window;

            // reverse the directions here, because
            // arrowLocation=left causes a tooltip to appear on the right of
            // the node, so for "left" tooltips we actually need to calculate how much
            // space is available to the right.
            const newState = {
                left: innerWidth - right,
                right: left,
                top: innerHeight - bottom,
                bottom: top,
            };

            this.setState({ availableSpace: newState });
        };

        setRef = (node) => {
            this._rootNode = node;
        };

        render() {
            const { arrowLocationPredicate, ...remainingProps } = this.props;
            const arrowLocation = arrowLocationPredicate(
                this.state.availableSpace,
            );

            return (
                <span
                    onFocus={this._handleUpdateDistances}
                    onMouseOver={this._handleUpdateDistances}
                    ref={this.setRef}
                >
                    <WithTooltipWrapper
                        {...remainingProps}
                        tooltipArrowLocation={arrowLocation}
                    />
                </span>
            );
        }
    };

export default withTooltipArrowLocationCalculator;
